import { Link }          from 'framework7-react';
import classnames        from 'classnames';
import NotificationBadge from '../components/notification_badge';
import React             from 'react';


export default function TabPageLink({ href, badgeCount, icon, title, subtitle, children, onClick, active = false, isExternal = false, className = '' }) {
  const tabClassName    = `tab-page-link ${className}`;
  const anchorTarget    = isExternal ? '_blank' : '_self';
  const anchorRel       = isExternal ? 'noopener noreferrer' : '';
  const anchorClassName = classnames('item-link item-content', { 'external': isExternal, 'item-link--highlight': active });

  return (
    <li className={tabClassName}>
      <Link href={href} target={anchorTarget} rel={anchorRel} className={anchorClassName} onClick={onClick}>
        <TabLinkIcon icon={icon}/>
        <div className="tab-page-link__inner item-inner">
          <div className="item-title-row">
            <div className="tab-page-link__title item-title">{title}</div>
            <NotificationBadge className="badge-count" color="red" count={badgeCount}/>
            <div className="item-after"></div>
          </div>
          <div className="tab-page-link__subtitle item-subtitle">{subtitle || children}</div>
        </div>
      </Link>
    </li>
  );
}

function TabLinkIcon({ icon }) {
  const isStringIcon = typeof icon === 'string';
  const isObjectIcon = typeof icon === 'object';

  if (isStringIcon || isObjectIcon) {
    return (
      <div className="tab-page-link__icon-container item-media">
        {isStringIcon && <i className={`icons8 icons8-${icon}`}/>}
        {isObjectIcon && icon}
      </div>
    );
  } else
    return null;
}
